<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-04 09:38:22
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-18 16:00:53
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEue
-->
<template>
    <div class="footer">
        <div v-if="step == 0" class="giveup btn" @click="giveup"> 放弃注册 </div>
        <div v-if="step != 0" class="giveup btn" @click="back"> 上一步 </div>
        <div class="confirm btn" @click="confirm"> 确认 </div>
    </div>
</template>

<script>
import { debounce } from "@/utils/core.js"
export default {
    name: '',
    props:{
        step: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        // 上一步
        back() {
            this.$emit("back", { data: this.params, step: this.step })
        },
        // 下一步
        confirm: debounce(function () {
            // 校验表单是否有为空的内容
            this.$emit("confirm", { data: this.params, step: 0 })
        }, 1000, true),
        // 放弃注册
        giveup() {
            this.$emit("giveup")
        }
    },
};
</script>

<style scoped lang="scss">
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    width: 100vw;
    height: 60px;
    padding: 10px 15px 0;
    background-color: #fff;
    box-sizing: border-box;

    .btn {
        width: 150px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 16px;
        border-radius: 22px;
        border: 1px solid transparent;
    }

    .giveup {
        border: 1px solid #D3D3D3;
        color: #999999;
    }

    .confirm {
        color: #FFFFFF;
        background: linear-gradient(93deg, #F42A2A 0%, #C12E2E 100%);
    }
}
</style>
